import { createSelector } from "reselect";
import orderByName from "../utils/orderByName";

export const getRecipes = (state) => state.entities.recipes;

export const getAllRecipes = createSelector(getRecipes, (recipes) =>
  Object.values(recipes).sort(orderByName)
);
